import React from "react";

const ActionButton = (props) => {
  return (
    <button type="button" onClick={props.onClick}>
      {props.icon && props.icon}
      {props.label}
    </button>
  );
};

export default ActionButton;
